import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import CopyOrganizationNoteToClients, {
    useCopyOrganizationNoteToClientsState,
} from '../../../../shared/ClientRecord/CopyOrganizationNoteToClients';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('copy-organization-notes-screen', {
    resourceNotes: 'Resource Notes',
    cancel: 'Cancel',
    share: 'Share',
});

export type CopyOrgNotesToClientsScreenOwnProps = {};

export type CopyOrgNotesToClientsScreenProps = CopyOrgNotesToClientsScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'copy-org-note-to-clients'>;
};

const CopyOrgNotesToClientsScreen: React.FC<CopyOrgNotesToClientsScreenProps> = ({ route }) => {
    const goBack = useGoBack();
    const { isInitializing, isSubmitting, selectedNoteIds, noteSelectOptions, onSubmit, canSubmit, onNoteSelection } =
        useCopyOrganizationNoteToClientsState({
            onClose: goBack,
            destinationMedicalProfileIds: route.params.medicalProfileIds,
        });

    const isLoading = isInitializing || isSubmitting;
    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <ActionButtonLayout
                    actions={[
                        {
                            title: intl('cancel'),
                            variant: 'secondary',
                            onPress: goBack,
                            isDisabled: isLoading,
                            testID: 'form-submit-cancel',
                            icon: 'XCircle',
                        },
                        {
                            title: `${intl('share')}${selectedNoteIds.length ? ` (${selectedNoteIds.length})` : ''}`,
                            variant: 'primary',
                            onPress: onSubmit,
                            isDisabled: !canSubmit || isLoading,
                            testID: 'form-submit-button',
                            icon: 'Share2',
                        },
                    ]}
                >
                    <CopyOrganizationNoteToClients
                        noteSelectOptions={noteSelectOptions}
                        selectedNoteIds={selectedNoteIds}
                        onNoteSelection={onNoteSelection}
                        isDisabled={isSubmitting}
                    />
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(CopyOrgNotesToClientsScreen);
